/**
 * @file Used to persist map state between site navigation
 */
import { assetTypes, type AssetType } from "@/assets/asset-labels";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

type Coordinates = [number, number];

interface MapState {
  /** A JSONLogic query */
  filterQuery: string | null;
  activeAssetTypes: AssetType[];
  center: Coordinates | null;
  zoom: number | null;
  rotation: number;
}

const initialState: MapState = {
  filterQuery: null,
  center: null,
  zoom: null,
  rotation: 0,
  activeAssetTypes: [...assetTypes],
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setFilterQuery: (state, { payload }: PayloadAction<string | null>) => {
      state.filterQuery = payload;
    },
    setActiveAssetTypes: (state, { payload }: PayloadAction<AssetType[]>) => {
      state.activeAssetTypes = payload;
    },
    setZoom: (state, { payload }: PayloadAction<number>) => {
      state.zoom = payload;
    },
    setCenter: (state, { payload }: PayloadAction<Coordinates>) => {
      state.center = payload;
    },
    setRotation: (state, { payload }: PayloadAction<number>) => {
      state.rotation = payload;
    },
  },
});

export default mapSlice.reducer;
export const {
  setFilterQuery,
  setZoom,
  setCenter,
  setRotation,
  setActiveAssetTypes,
} = mapSlice.actions;

interface RootState {
  map: MapState;
}

export function selectFilterQuery(state: RootState): string | null {
  return state.map.filterQuery;
}
